/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_SubtitleInputs */

const vi_shop_home_subtitle = /** @type {(inputs: Shop_Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng phụ`)
};

/**

* @param {Shop_Home_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_subtitle = /** @type {((inputs?: Shop_Home_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_subtitle(inputs)
});